import { Box, Paper, Typography, Stack } from '@mui/material';
import SportsIcon from '@mui/icons-material/Sports';

// ── À compléter selon les besoins de l'entraîneur ────────────────────────
const CoachDashboard = ({ user }) => (
  <Box>
    <Typography variant="h4" sx={{ color: '#fff', fontWeight: 900, mb: 1 }}>
      Bonjour, {user.firstName} 👋
    </Typography>
    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,.4)', mb: 4 }}>Vue Entraîneur</Typography>

    <Paper sx={{
      p: 6, borderRadius: 3, textAlign: 'center',
      bgcolor: 'rgba(255,255,255,.03)', border: '1px solid rgba(59,130,246,.2)',
    }}>
      <SportsIcon sx={{ fontSize: 60, color: '#3B82F6', mb: 2, opacity: .5 }} />
      <Typography variant="h6" sx={{ color: 'rgba(255,255,255,.5)', fontWeight: 600 }}>
        Tableau de bord Entraîneur
      </Typography>
      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,.3)', mt: 1 }}>
        Importez <code>CoachDashboard.js</code> et construisez la vue ici.
      </Typography>
    </Paper>
  </Box>
);

export default CoachDashboard;
